import React, { memo, useEffect, useState } from "react";
import { csv } from "d3-fetch";
import { scaleLinear } from "d3-scale";
import { findMaxMinLog }  from "../../utils/common-functions";
import {
   ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography,
  Sphere,
  Graticule
} from "react-simple-maps";
import { useSelector } from 'react-redux';


const geoUrl =
  "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json";


const rounded = num => {
   if(num >= 1000000){
          return (num/1000000).toFixed(2) + "m"
        } else if(num >= 1000){
          return (num/1000).toFixed(2) + "k"
        }else{
          return num
        }
};




let colorScale;

const MapChart = ({ setTooltipContent }) => {
  const [data, setData] = useState([]);
  const countries =  useSelector(state => state.data.countries);
  
  

  useEffect(() => {
     setData(countries)
     const val = findMaxMinLog(countries)

     colorScale =  scaleLinear()
                        .domain([ val.min, val.center, val.max])
                        .range(["green", "yellow", "#ff5233"]);
     
     
  
  }, []);

  return (
    <ComposableMap
      data-tip=""
      projectionConfig={{
        rotate: [-10, 0, 0],
        scale: 200
      }}
    >  <ZoomableGroup>
      <Sphere stroke="#E4E5E6" strokeWidth={0.5} />
      <Graticule stroke="#E4E5E6" strokeWidth={0.5} />
      {data.length > 0 && (
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map(geo => {
              const d = data.find(s => s.countryInfo.iso3 === geo.properties.ISO_A3);
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={d ? colorScale(Math.log(d.cases)) : "green"}
                  onMouseEnter={() => {
                    const { NAME } = geo.properties;
                    setTooltipContent(`${NAME} — ${d ? rounded(d.cases): 0} cases, ${d ? rounded(d.deaths): 0} deaths`);
                  }}
                  onMouseLeave={() => {
                    setTooltipContent("");
                  }}
                  style={{
                    default: {
                      
                      outline: "none"
                    },
                    hover: {
                      fill: "blue",
                      outline: "none"
                    },
                    pressed: {
                      fill: "#E42",
                      outline: "none"
                    }
                  }}
                />
              );
            })
          }
        </Geographies>
      )}
       </ZoomableGroup>
    </ComposableMap>
  );
};

export default memo(MapChart);
